export default function Footer({ catalog }) {
  return (
    <footer className="bg-forest-900 text-parchment/70 text-sm">
      <div className="max-w-6xl mx-auto px-5 py-10 flex flex-col sm:flex-row gap-4 justify-between pb-28 sm:pb-10">
        <div>
          <p className="font-serif text-2xl text-parchment font-bold">HithAyu Wellness</p>
          <p className="mt-1">{catalog?.address}</p>
        </div>
        <div className="sm:text-right">
          <p>+91 {catalog?.phone}</p>
          <p className="mt-1">© {new Date().getFullYear()} Hithayu Wellness</p>
        </div>
      </div>
    </footer>
  );
}
